let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("43w6L")).then(() => parcelRequire('hNvPB'));